import './spinner.scss'

export const Spinner = () => {
  return (
    <div className="spinner" />
    )
}